


























import { Component, Vue } from 'vue-property-decorator'

@Component
export default class LoadingSearch extends Vue {
  created() {}
}
